import React, { FC, ReactNode, useEffect, useState } from 'react';
import { mockViewChargeHistoryResponse } from '../mocks/order-details/ViewChargedDetailsMocks';
import { IViewChargeHistoryResponse } from '../models/responses/oms';
import {
  TCurrentLineItemsView,
  ViewChargedDetailsContext,
} from './ViewChargedDetailsContext';

interface IViewChargedDetailsProviderProps {
  children: ReactNode;
}

export const ViewChargedDetailsProvider: FC<
  IViewChargedDetailsProviderProps
> = ({ children }) => {
  const [openChargedDetailsDrawer, setOpenChargedDetailsDrawer] =
    useState(false);
  const [chargeHistoryData, setChargeHistoryData] = useState<
    IViewChargeHistoryResponse | undefined
  >(undefined);
  const [chargeHistoryLoading, setChargeHistoryLoading] = useState(true);
  const [chargeHistoryError, setChargeHistoryError] = useState<
    Error | undefined
  >(undefined);
  const [currentLineItemsView, setCurrentLineItemsView] = useState<
    TCurrentLineItemsView | undefined
  >(undefined);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const fetchChargeDetails = async () => {
      try {
        // Simulate network delay — replace with real API call when available
        await new Promise((resolve) => {
          timeoutId = setTimeout(resolve, 2000);
        });
        setChargeHistoryData(mockViewChargeHistoryResponse);
        setChargeHistoryLoading(false);
      } catch (err) {
        setChargeHistoryError(err as Error);
        setChargeHistoryLoading(false);
      }
    };

    if (openChargedDetailsDrawer) {
      fetchChargeDetails();
    }

    return () => clearTimeout(timeoutId);
  }, [openChargedDetailsDrawer]);

  return (
    <ViewChargedDetailsContext.Provider
      value={{
        openChargedDetailsDrawer,
        setOpenChargedDetailsDrawer,
        chargeHistoryData,
        chargeHistoryLoading,
        chargeHistoryError,
        currentLineItemsView,
        setCurrentLineItemsView,
      }}
    >
      {children}
    </ViewChargedDetailsContext.Provider>
  );
};
